import { Component, OnInit } from '@angular/core';
import { AdobeLaunchService } from 'src/app/shared/services/adobe-launch.service';

@Component({
  selector: 'student-privacy-notice',
  templateUrl: './student-privacy-notice.component.html',
  styleUrls: ['./student-privacy-notice.component.scss'],
})
export class StudentPrivacyNoticeComponent implements OnInit {
  constructor(
    private readonly adobeLaunchService: AdobeLaunchService,
  ) {}

  ngOnInit(): void {
    this.adobeLaunchService.trackPageView({
      pageTitle: 'Student Privacy Notice',
    });
  }
}
